import { datadogRum } from '@datadog/browser-rum';

import { DATADOG_SITE } from '../../config';

let isInitialized = false;

function buildAllowedTracingUrls(): (string | RegExp | ((url: string) => boolean))[] {
  const domain = process.env.NEXT_PUBLIC_SITE_DOMAIN || '';
  const apiUrl = process.env.NEXT_PUBLIC_API_URL || '';
  const urls: (string | RegExp | ((url: string) => boolean))[] = [];

  if (domain) {
    urls.push(`https://${domain}`);
    const escaped = domain.replace(/\./g, '\\.');
    urls.push(new RegExp(`^https:\\/\\/[^/]*\\.${escaped}`));
    urls.push((url: string) => url.startsWith(`https://${domain}`));
  }

  if (apiUrl) {
    try {
      const host = new URL(apiUrl).hostname;
      urls.push(`https://${host}`);
      const escaped = host.replace(/\./g, '\\.');
      urls.push(new RegExp(`^https:\\/\\/${escaped}`));
    } catch {
      // ignore
    }
  }

  return urls;
}

export function initDatadogRum() {
  if (typeof window === 'undefined') {
    // Never run on the server
    return;
  }

  if (isInitialized) return;

  const applicationId = process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID;
  const clientToken = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN;

  if (!applicationId || !clientToken) {
    console.warn(
      '[Datadog RUM] Missing NEXT_PUBLIC_DATADOG_APPLICATION_ID or NEXT_PUBLIC_DATADOG_CLIENT_TOKEN — skipping init',
    );
    return;
  }

  isInitialized = true;

  const service = process.env.NEXT_PUBLIC_DD_SERVICE || 'ilotto-web';
  const env = process.env.NEXT_PUBLIC_ENV || process.env.NODE_ENV || 'production';
  const version = process.env.NEXT_PUBLIC_VERSION || '0.0.0';
  const sessionSampleRate = Number(process.env.NEXT_PUBLIC_DD_SESSION_SAMPLE_RATE || '1');
  const sessionReplaySampleRate = Number(
    process.env.NEXT_PUBLIC_DD_SESSION_REPLAY_SAMPLE_RATE || '20',
  );

  datadogRum.init({
    applicationId,
    clientToken,
    site: DATADOG_SITE,
    service,
    env,
    version,
    sessionSampleRate,
    sessionReplaySampleRate,
    trackBfcacheViews: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: buildAllowedTracingUrls(),
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
  });

  datadogRum.startSessionReplayRecording();
}
